import NeuralNetworksImg from '../assets/neural-networks.jpg';
import GenerativeAICertficateImg from '../assets/coursera/certificate-generative-ai-with-llm.jpg';
import NeuralNetworksCertificateImg from '../assets/coursera/certificate-neural-networks-and-deep-learning.jpg';
import ConvolutionalNeuralNetworksCertificateImg from '../assets/coursera/certificate-convolutional-neural-networks.jpg';
import DeepLearningWithPyTorchImageSegmentationCertificateImg from '../assets/coursera/certificate-deep-learning-with-pytorch-image-segmentation.jpg';

export const certificates = [
    // Generative AI with LLM
    {
        name: 'Generative AI with LLM',
        image: GenerativeAICertficateImg
    },

    // Neural Networks and Deep Learning
    {
        name: 'Neural Networks and Deep Learning',
        image: NeuralNetworksCertificateImg
    },

    // Convolutional Neural Networks
    {
        name: 'Convolutional Neural Networks',
        image: ConvolutionalNeuralNetworksCertificateImg
    },

    // Deep Learning with PyTorch : Image Segmentation
    {
        name: 'Deep Learning with PyTorch : Image Segmentation',
        image: DeepLearningWithPyTorchImageSegmentationCertificateImg
    }

];